import AuthProvider from '@/contexts/auth-context/auth-provider';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { Toaster } from '@/components/sonner/sonner';
import TooltipProvider from '@/components/providers/tooltip-provider/tooltip-provider';
import TanstackReactQueryProvider from '@/components/providers/tanstack-query-provider/tanstack-query-provider';
import AppError from '@/components/errors/app-error/app-error';
import { HelmetProvider } from 'react-helmet-async';
import V2DialogProvider from '@/contexts/dialog-context/v2-dialog-provider';

const CHUNK_RELOAD_KEY = 'chunk-reload';

// ponytail: reload sekali saat chunk lazy gagal dimuat (Vite re-optimize deps di dev,
// hash chunk berubah setelah deploy di prod). Guard sessionStorage cegah loop.
function reloadOnChunkError(error: Error) {
  const isChunkError =
    /dynamically imported module|Importing a module script failed/i.test(
      error.message
    );

  const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);

  if (!isChunkError || Date.now() - lastReload < 10_000) return;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
}

interface AppProviderProps {
  children: React.ReactNode;
}
export default function AppProvider({ children }: AppProviderProps) {
  return (
    <ErrorBoundary FallbackComponent={AppError} onError={reloadOnChunkError}>
      <HelmetProvider>
        <BrowserRouter>
          <NuqsAdapter>
            <TanstackReactQueryProvider>
              <AuthProvider>
                <TooltipProvider>
                  <V2DialogProvider>{children}</V2DialogProvider>
                </TooltipProvider>
                <Toaster richColors position="top-center" />
              </AuthProvider>
            </TanstackReactQueryProvider>
          </NuqsAdapter>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}
